import { render, staticRenderFns } from "./ResetForgottenPasswordComponent.vue?vue&type=template&id=7a2d7a90"
import script from "./ResetForgottenPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ResetForgottenPasswordComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports